import React, { Component } from 'react';
import { Dropdown, DropdownMenu, DropdownItem } from 'reactstrap';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {BASE_URL} from '../../constants';

class Header extends Component {

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false
    };
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-hidden');
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-mobile-show');
  }

  asideToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('aside-menu-hidden');
  }

  render() {
    let {siteConfig} = this.props;
    
    return (
      <header className={`app-header navbar navbar-${siteConfig.styleName}`} style={{height: '75px'}}>
        <button className="navbar-toggler mobile-sidebar-toggler hidden-lg-up" onClick={this.mobileSidebarToggle} type="button">&#9776;</button>
        <a className={`navbar-brand header-${siteConfig.styleName}`} href="#" style={{height: '60px', backgroundColor: 'inherit', marginTop: '5px'}} />
        <ul className="nav navbar-nav hidden-md-down">
          <li className="nav-item">
            <a className="nav-link navbar-toggler sidebar-toggler" onClick={this.sidebarToggle} href="#">&#9776;</a>
          </li>
          <li className="nav-item px-1">
            <Link to={`${BASE_URL}/`} className="nav-link"> Home </Link>
          </li>
          {/*<li className="nav-item px-1">
            <Link to={`${BASE_URL}/checklists/driver/pre`} className="nav-link" activeClassName="active"> Pre Checklist </Link>
          </li>
          <li className="nav-item px-1">
            <Link to={`${BASE_URL}/checklists/driver/post`} className="nav-link" activeClassName="active"> Post Checklist </Link>
          </li>*/}
        </ul>
        {/*
        <ul className="nav navbar-nav ml-auto">
          <li className="nav-item hidden-md-down">
            <a className="nav-link" href="#" onClick={this.asideToggle}><i className="icon-bell"></i><span className="badge badge-pill badge-danger">5</span></a>
          </li>
          <li className="nav-item hidden-md-down">
            <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
              <a onClick={this.toggle} className="nav-link dropdown-toggle nav-link" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded={this.state.dropdownOpen}>
                <span className="hidden-md-down">{this.props.account.user.userName}&nbsp;</span>
              </a>

              <DropdownMenu className="dropdown-menu-right">
                <DropdownItem header className="text-center"><strong>Account</strong></DropdownItem>

                <DropdownItem><i className="fa fa-envelope-o"></i> Messages<span className="badge badge-success">42</span></DropdownItem>
                <DropdownItem><i className="fa fa-lock"></i> Logout</DropdownItem>

              </DropdownMenu>
            </Dropdown>
          </li>
        </ul>*/}
      </header>
    );
  }
}

Header.propTypes = {
  account: PropTypes.object,
  siteConfig: PropTypes.object.isRequired,
};

export default Header;
